/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * SubsPaymentSheetResponseBase
 * auto generated base class for the model SubsPaymentSheetResponseModel.
 */
export const SubsPaymentSheetResponseModelBase = ModelBase.named('SubsPaymentSheetResponse')
  .props({
    __typename: types.optional(types.literal('SubsPaymentSheetResponse'), 'SubsPaymentSheetResponse'),
    customer: types.union(types.undefined, types.string),
    ephemeralKey: types.union(types.undefined, types.string),
    isFree: types.union(types.undefined, types.boolean),
    paymentIntent: types.union(types.undefined, types.string),
    publishableKey: types.union(types.undefined, types.string),
    subscriptionId: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SubsPaymentSheetResponseModelSelector extends QueryBuilder {
  get customer() {
    return this.__attr('customer')
  }
  get ephemeralKey() {
    return this.__attr('ephemeralKey')
  }
  get isFree() {
    return this.__attr('isFree')
  }
  get paymentIntent() {
    return this.__attr('paymentIntent')
  }
  get publishableKey() {
    return this.__attr('publishableKey')
  }
  get subscriptionId() {
    return this.__attr('subscriptionId')
  }
}
export function selectFromSubsPaymentSheetResponse() {
  return new SubsPaymentSheetResponseModelSelector()
}

export const subsPaymentSheetResponseModelPrimitives =
  selectFromSubsPaymentSheetResponse().customer.ephemeralKey.isFree.paymentIntent.publishableKey.subscriptionId
